import styled from 'styled-components'

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  min-height: 100vh;
  padding: ${props => props.theme.whiteLabel.spacing.sp16};
  box-sizing: border-box;
  background-color: ${props => props.theme.colors.grey.tone50};
`

export const Logo = styled.img`
  height: ${props => props.theme.whiteLabel.spacing.sp32};
`

export const CardContainer = styled.div`
  width: 100%;
  max-width: calc(${props => props.theme.whiteLabel.spacing.sp64} * 7);
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const LegalLinks = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
